import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { SharedModule } from '../../../shared/shared.module';
import { SharedValidatorsModule } from '../../../shared/validators/shared-validators.module';
import { FinanceSharedModule } from '../../finance-shared.module';
import { DisbursementService } from '../../services/disbursement.service';
import { DisbursementRequestConfirmationModalComponent } from './disbursement-request-confirmation-modal.component';
import { DisbursementRequestConfirmationComponent } from './disbursement-request-confirmation.component';
import { DisbursementRequestComponent } from './disbursement-request.component';

@NgModule({
    declarations: [
        DisbursementRequestComponent,
        DisbursementRequestConfirmationModalComponent,
        DisbursementRequestConfirmationComponent
    ],
    providers: [
        DisbursementService
    ],
    imports: [
        SharedModule,
        CommonModule,
        ReactiveFormsModule,
        FinanceSharedModule,
        SharedPipesModule,
        SharedValidatorsModule,
        ValidationResultsModule
    ],
    exports: [
        DisbursementRequestComponent
    ]
})
export class DisbursementRequestModule {
}
